// rem等比适配配置文件
// 基准大小
const baseSize = 100; // 注意此值要与 postcss.config.js 文件中的 rootValue保持一致
// 设置 rem 函数
function setRem() {
  // 设计图标准按1920*1080计算。
  const scale = (document.documentElement.clientWidth / 1920).toFixed(5); // 保留5位小数
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function() {
  setRem();
};

(function (win) {
  var dom = document.documentElement || document.body
  const fun = 'orientationchange' in window ? 'orientationchange' : 'resize'
  // 上边这句的意思是判断是屏幕尺寸改变还是屏幕旋转。 (可以移动端适配)
  const cb = function () {
    // var clientWidth = dom.clientWidth < 800 ? 800 : dom.clientWidth // 这里限制pc端 最小800宽度
    // 移动端：
    var clientWidth = dom.clientWidth
    // clientWidth = clientWidth < 375 ? 375 : clientWidth
    // clientWidth = clientWidth <= 750 ? 375 : clientWidth
    // // clientWidth = clientWidth > 750 ? 750 : clientWidth
    // clientWidth = clientWidth > 750 ? clientWidth : 375 // 改
    // 移动端最小375宽度，最带750宽度
    dom.style.fontSize = clientWidth / 10 + 'px'
  }
  cb()
  win.addEventListener(fun, cb, false)
})(window)
